import "./styles/typography.css";
import Modal from "./components/Modal";
import modalState from "./state-observables/modal/ModalState";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import styles from "./app.module.css";
import {
  ModalEventTopics,
  ModalStateData,
} from "./state-observables/modal/ModalObserver";
import { useEffect, useState } from "react";
import QuestionOfTheWeekSection from "./sections/QuestionOfTheWeek";
import StatusButtonsSection from "./sections/StatusButtonsSection";
import NewsFeedSection from "./sections/NewsFeedSection";
import NoticeBoardSection from "./sections/NoticeBoardSection";
import IdeaOfTheWeekSection from "./sections/IdeaOfTheWeekSection";
import { Tooltip as ReactTooltip } from 'react-tooltip'


function App() {
  const [modalData, setModalData] = useState<null | ModalStateData>(null);
  const [shouldCloseModal, setShouldCloseModal] = useState(false);
  const [isEducator, setIsEducator] = useState(false);

  const modalSubscriptionHelper = {
    notify(eventTopic: ModalEventTopics, eventData: ModalStateData) {
      switch (eventTopic) {
        case "SetModal":
          setModalData(eventData);
          break;
        case "CloseModal":
          setShouldCloseModal(true);
          break;
        case "UpdateModalProps":
          setModalData((prevModalData) => {
            if (prevModalData) {
              return {
                ...prevModalData,
                ...eventData,
              };
            }
            return prevModalData;
          });
          break;
      }
    },
  };

  // Create subscription to the modal states
  useEffect(() => {
    // Subscribe
    modalState.subscribe(modalSubscriptionHelper, ["SetModal", "CloseModal", "UpdateModalProps"]);
    // Return unsubscribe function
    return () => {
      modalState.unsubscribe(modalSubscriptionHelper);
    };
  }, []);

  useEffect(() => {
    // get the educator status from storage session
    const isEducator = sessionStorage.getItem("isEducator");
    if (isEducator) {
      setIsEducator(isEducator === "true");
    }
  }
    , []);

  const resetModal = () => {
    setShouldCloseModal(false);
    setModalData(null);
  };

  const onEducatorChange = (isEducator: boolean) => {
    setIsEducator(isEducator);
    // store the educator status in storage session
    sessionStorage.setItem("isEducator", isEducator.toString());
  }

  const ModalContent = modalData?.modalContent;
  const bottomStylesBasedOnEducatorStatus: React.CSSProperties = {};
  if (!isEducator) {
    // bottomStylesBasedOnEducatorStatus.gridTemplateColumns = "1fr";
  }
  const mainStylesBasedOnEducatorStatus: React.CSSProperties = {};
  if (!isEducator) {
    mainStylesBasedOnEducatorStatus.justifyContent = "flex-end";
  }
  return (
    <div className={[styles.appOuterContainer, isEducator ? styles.appOuterContainerEducator : ""].join(" ")}>
      <ToastContainer />
      <ReactTooltip
        id="tooltip"
        key={new Date().toISOString()}
      />
      {/* <AppVersionWarning />
      <MartyVersionWarning /> */}
      {!!ModalContent && (
        <Modal
          title={modalData ? modalData.modalTitle || "" : ""}
          modalResetter={resetModal}
          shouldCloseModal={shouldCloseModal}
          withLogo
          withCloseButton={modalData?.withCloseButton}
        >
          {ModalContent}
        </Modal>
      )}
      <header >
      </header>
      <main className={styles.main} style={mainStylesBasedOnEducatorStatus}>
        {isEducator && <div className={styles.topContainer}>
          <NewsFeedSection />
          <div className={styles.vr_top} />
          <NoticeBoardSection />
          <IdeaOfTheWeekSection />
        </div>}
        {isEducator && <hr className={styles.hr} />}
        <div className={styles.bottomContainer} style={bottomStylesBasedOnEducatorStatus}>
          <QuestionOfTheWeekSection visibility={isEducator ? "visible" : "hidden"} />
          <div className={styles.vr} style={{ visibility: isEducator ? "visible" : "hidden"  }} />
          <StatusButtonsSection setIsEducator={onEducatorChange} isEducator={isEducator} />
        </div>
      </main>
    </div>
  );
}

export default App;
